import React from "react";
import { FaArrowRight } from "react-icons/fa";
import PaginationButton from "./PaginationButton";

const PaginationButtonNext = ({ onClick, disabled = false, fontSize = undefined, hidden = false }) => {
    return <PaginationButton hidden={hidden} icon={<FaArrowRight fontSize={fontSize} />} onClick={onClick} disabled={disabled} />
}

export default PaginationButtonNext;
